import { render } from "./FormGroup.vue?vue&type=template&id=72a31b40&scoped=true&bindings={\"label\":\"props\",\"patternLabel\":\"props\",\"req\":\"props\",\"optional\":\"props\",\"changeSelect\":\"setup\"}"
import script from "./FormGroup.vue?vue&type=script&lang=ts"
export * from "./FormGroup.vue?vue&type=script&lang=ts"

import "./FormGroup.vue?vue&type=style&index=0&id=72a31b40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72a31b40"

export default script